export const SHIFT_TASKS_WIDGET_NAMESPACE = 'widget.shift-tasks'
